



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AudioPlayer from '@/views/AiiTasks/AudioPlayer.vue'
import { getStyleProperty, getSideMenuWidth } from '@/utils/util'
import { formatDatetime } from '@/web-task/filter'
import {
	DAI_ZHONG_SHEN,
	DAI_QUE_REN,
	YI_WAN_CHENG,
	YI_QU_XIAO,
	YI_GUAN_DAN,
} from '@/web-task/config'

@Component({
	components: {
		AudioPlayer,
	},
})
export default class RecordList extends Vue {
	private tableData: any = []
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'key',
			width: 100,
		},
		{
			title: '录音信息',
			dataIndex: 'name',
			width: 180,
		},
		{
			title: '操作',
			dataIndex: 'operation',
			scopedSlots: { customRender: 'operation' },
			width: 180,
		},
		{
			title: '拨打时间',
			dataIndex: 'startTime',
			scopedSlots: { customRender: 'timeFormat' },
			width: 150,
		},
		// {
		// 	title: '响铃时间',
		// 	dataIndex: 'ringTime',
		// scopedSlots: { customRender: 'timeFormat' },
		// 	width: 150,
		// },
		{
			title: '时长',
			dataIndex: 'duration',
			width: 150,
		},
	]
	private show = false

	@Prop({ default: () => [] })
	private recordList!: any

	// 3016 作业录音 3017 调解录音
	// @Prop({ default: () => ['3016', '3017'] })
	// private recordTypeList!: any

	@Prop({})
	private orderStatus!: string

	@Prop()
	private playingId!: string

	@Prop({
		default: () => [
			DAI_ZHONG_SHEN,
			DAI_QUE_REN,
			YI_WAN_CHENG,
			YI_QU_XIAO,
			YI_GUAN_DAN,
		],
	})
	private customShowStatus!: string[]

	@Watch('recordList', { immediate: true })
	private onRecordListChange() {
		this.getTableData()
	}

	// private get recordShow(): boolean {
	// 	// 订单状态为：待终审、待确认、已完成、已取消、已关单才能看见录音信息
	// 	const statusList = this.customShowStatus
	// 	return (
	// 		this.tableData &&
	// 		this.tableData.length > 0 &&
	// 		statusList.includes(this.orderStatus)
	// 	)
	// }

	private formatDatetime(time: number) {
		return formatDatetime(time)
	}

	private play(recordObj: any) {
		this.$emit('onPlay', recordObj)
	}

	private download(recordObj: any) {
		window.open(recordObj.picUrl)
	}

	private getTableData() {
		let res: any = [],
			num: number = 0
		// let recordMap = this.list2Map(this.recordList)
		// this.recordTypeList.forEach((typeCode: string) => {
		// 	let typeList = recordMap[typeCode] || []
		// 	typeList.forEach((record: any, index: number) => {
		// 		res.push(
		// 			Object.assign({}, record, {
		// 				key: ++num,
		// 				name: `${record.picName} ${typeList.length > 1 ? index + 1 : ''}`,
		// 			})
		// 		)
		// 	})
		// })
		this.recordList.forEach((record: any, index: number) => {
			res.push(
				Object.assign({}, record, {
					key: ++num,
					name: `${record.picName} ${
						this.recordList.length > 1 ? index + 1 : ''
					}`,
					picUrl: record.fileUrl,
				})
			)
		})
		this.tableData = res
		return res
	}

	private list2Map(recordList: any[]) {
		const obj: any = {}
		if (recordList && recordList.length) {
			for (const record of recordList) {
				if (!obj[record.type]) {
					obj[record.type] = []
				}
				obj[record.type].push(record)
			}
		}

		return obj
	}
}
